import {
    LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,
    LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR,
    LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN,
    LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE,
    LOAD_PICK_PACKAGE_METRICS_FOR_NODE,
    LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR,
    LOAD_STOW_FLOOR_METRICS_FOR_NODE,
    LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR,
    LOAD_STOW_PACKAGE_METRICS_FOR_NODE,
    LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR
} from "../actions/StationPairActions";

/**
 * Initial state of the system.
 */

const initialState = {
    loading: true,
    inductPackageMetricsMap: {},
    pickPackageMetricsMap: {},
    stowAssociateMetricsMap: {},
    stowFloorMetricsGroupMap: {},
    stowPackageMetricsMap: {},
    totalInductPackageMetrics: {},
    totalPickPackageMetricsMap: {},
    totalStowAssociateMetrics: {},
    totalStowFloorMetricsMap: {},
    totalStowPackageMetrics: {},
}

/**
 * Reducer function for Station Pair View that changes state
 * based on the action triggered.
 */
export default function stationPairReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_STATION_PAIR_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalInductPackageMetrics: action.totalInductPackageMetrics
            }
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_STATION_PAIR:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMap: action.inductPackageMetricsMap
            };
        case LOAD_PICK_PACKAGE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalPickPackageMetricsMap: action.totalPickPackageMetricsMap
            }
        case LOAD_PICK_PACKAGE_METRICS_FOR_STATION_PAIR:
            return {
                ...state,
                loading: false,
                pickPackageMetricsMap: action.pickPackageMetricsMap
            }
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowAssociateMetrics: action.totalStowAssociateMetrics
            }
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_STATION_PAIR:
            return {
                ...state,
                loading: false,
                stowAssociateMetricsMap: action.stowAssociateMetricsMap
            };
        case LOAD_STOW_FLOOR_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowFloorMetricsMap: action.totalStowFloorMetricsMap
            };
        case LOAD_STOW_FLOOR_METRICS_FOR_STATION_PAIR:
            return {
                ...state,
                loading: false,
                stowFloorMetricsGroupMap: action.stowFloorMetricsGroupMap
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowPackageMetrics: action.totalStowPackageMetrics
            }
        case LOAD_STOW_PACKAGE_METRICS_FOR_STATION_PAIR:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_METRICS_FOR_STATION_PAIR_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/StationPairReducer.js